module.exports = __webpack_public_path__ + "img/click_tab4.f2a1ae88.png";